if (typeof ARCHIPEL === "undefined") {
  var ARCHIPEL = {};
}

import { menu } from "./actions/menu";
import { carousel } from "./actions/carousel";
import { scroll } from "./actions/scroll";

import "../scss/styles.scss";
!function ($) {
  "use strict";

  jQuery(document).ready(function ($) {
    //scroll.init();
    carousel.init();
    menu.init();
  });
}.call(ARCHIPEL, jQuery);
